import Diff from "fast-diff";

import * as styles from "./TypeaheadBold.styles";

interface Props {
  queryText: string;
  typeaheadSuggestionText: string;
}

const TypeaheadBold = ({ queryText = "", typeaheadSuggestionText = "" }: Props) => {
  const lowercaseQuery = queryText?.toLowerCase() ?? "";
  const lowercaseTypeahead = typeaheadSuggestionText?.toLowerCase() ?? "";
  const diffs = Diff(lowercaseQuery, lowercaseTypeahead);

  const renderTypeaheadParts = () => {
    let remainingText = typeaheadSuggestionText;

    const properCaseText = (chunkText: string) => {
      const textLength = chunkText.length;
      const subTypeaheadText = remainingText.substring(0, textLength);
      remainingText = remainingText.substring(textLength);

      return subTypeaheadText;
    };

    return diffs.map(([diffType, text], index) => {
      if (typeof text !== "string") return null;

      if (diffType === 0) {
        return (
          <span data-testid="typeahead-regular" key={index} css={styles.regular}>
            {properCaseText(text)}
          </span>
        );
      }

      if (diffType === 1) {
        return (
          <span data-testid="typeahead-bold" key={index} css={styles.bold}>
            {properCaseText(text)}
          </span>
        );
      }

      return null;
    });
  };

  return <>{renderTypeaheadParts()}</>;
};

export { TypeaheadBold };
